import api from './api';

export interface TipoMedicao {
  id: string;
  nome: string;
  codigo:number
}

export interface FrequenciaMedicao {
  id: string;
  nome: string;
}

export interface FrequenciaMedicaoSla {
  id: string;
  nome: string;
}

export const getAllTiposMedicao = () => api.get<TipoMedicao[]>('frequenciasMedicao/tiposmedicao');
export const getAllFrequencias = () => api.get<FrequenciaMedicao[]>('frequenciasMedicao/frequencias');
export const getAllFrequenciasSla = () => api.get<FrequenciaMedicaoSla[]>('frequenciasMedicao/frequenciasSla');

export const getAllTiposMedicaoOptions = () =>
  getAllTiposMedicao().then(tipoMedicao => (tipoMedicao || []).map(a => ({ text: a.nome, value: a.codigo })));
export const getAllFrequenciasOptions = () =>
  getAllFrequencias().then(tipoMedicao => (tipoMedicao || []).map(a => ({ text: a.nome, value: a.id.toString() })));
export const getAllFrequenciasSlaOptions = () =>
  getAllFrequenciasSla().then(tipoMedicao => (tipoMedicao || []).map(a => ({ text: a.nome, value: a.id.toString() })));
